<script setup lang="ts">
import { i18n } from '@/i18n'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import Plus from '@/assets/plus.svg'

const router = useRouter()

const t = i18n.global.t

defineProps<{
  loggedIn: boolean
}>()

const emit = defineEmits<{
  createProject: []
}>()

const currentRoute = computed(() => router.currentRoute.value.name)
</script>

<template>
  <div
    class="bg sm:h-[65vh] min-h-128 w-full flex flex-col items-start justify-center bg-[#380525] text-white relative"
    :class="[currentRoute, currentRoute === 'favourites' ? 'bg-[#380525]' : 'bg-green']"
  >
    <div class="w-full max-w-[1512px] sm:px-[6rem] max-sm:px-[3rem] mx-auto">
      <h1 class="sm:text-6xl/19 max-sm:text-3xl mt-28 mb-7 md:mt-0 sm:max-w-[10em] font-medium">
        <slot name="heading"></slot>
      </h1>
      <h3
        class="sm:text-3xl/10 max-sm:text-xl font-alexandria font-extralight tracking-wider sm:max-w-[16em]"
      >
        <slot name="subtitle">{{ t('anInteractiveTool') }}</slot>
      </h3>
      <button
        v-if="currentRoute === 'build' && loggedIn"
        class="px-4 py-2 rounded-2xl bg-grey/20 absolute bottom-4 right-4 font-alexandria font-extralight flex flex-row items-center cursor-pointer"
        @click="emit('createProject')"
      >
        <img :src="Plus" class="w-4 mr-3 invert" />{{ t('createNewProjectButton') }}
      </button>
      <div
        v-else-if="currentRoute === 'build'"
        class="px-4 py-2 rounded-2xl bg-grey/20 absolute bottom-4 right-4 font-alexandria font-extralight flex flex-row items-center cursor-pointer"
      >
        <p>{{ t('signInToCreate') }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg {
  background-image: url('@/assets/pattern-diy.png');
}
.bg.favourites {
  background-image: url('@/assets/pattern-fav.png');
  background-size: 85% 85%;
}
</style>
